export namespace LocationsEvents {
	export class FetchAll {
		static readonly type = "[LocationsEvents] Fetch all";
	}

	export class SetFilter {
		static readonly type = "[LocationsEvents] Set Filter";
		constructor(public filter: any) {}
	}
}
